import styled from 'styled-components';
var BodyTextStyles = styled.p.withConfig({
  displayName: "BodyTextstyles__BodyTextStyles",
  componentId: "pantheon__vqeo6u-0"
})(["font-size:1rem;color:#454545;"]);
export { BodyTextStyles };